import { useState, useEffect } from 'react'
import EditProposedDebt from './editProposedDebt'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import BaseService from '../../../services/BaseService'
import DataGrid from '../../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import CommonService from "../../../services/CommonService"

const SearchResultContainer = (props) => {
  const [editProposedDebt, setEditProposedDebt] = useState(false);
  const [selectedProposedDebtInfo, setSelectedProposedDebtInfo] = useState([]);
  const {proposeDebtId, finalSaleId} = props;
  const [cdiacProposedDebt, setCdiacProposedDebt] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "center",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    setSelectedProposedDebtInfo(row);
    setEditProposedDebt(true);
  }

  const getProposedDebt = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getProposedDebtById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "proposeDebtId": proposeDebtId,
          "tableType": "Normal",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacProposedDebt(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }
  useEffect(() => {
    if (proposeDebtId){
      getProposedDebt();
    }
    // eslint-disable-next-line
  }, [proposeDebtId]);

  const columns = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  }, {
    dataField: 'projectName',
    text: 'Project Name',
    sort: true,
  }, {
    dataField: 'principalSaleAmt',
    text: 'Principal Sale Amount',
    sort: true,
    formatter: (row) => CommonService.currencyFormatter(row.principalSaleAmt),
   }, {
    dataField: 'proposedSaleDate',
    text: 'Proposed Sale Date',
    sort: true,
    formatter: (row) => CommonService.dateFormatter(row.proposedSaleDate),
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditProposedDebt(false);
    getProposedDebt();
  }


  return (
    <>
      <hr/>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <h2>Search Result: </h2>
        <DataGrid
            title="Report of Proposed Debt Issuance"
            dataSource={cdiacProposedDebt}
            sortField='proposeDebtId'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
        </DataGrid>
      </div>
      {editProposedDebt && <EditProposedDebt onModalClose={() => handleModalClose()} proposedDebtInfo={selectedProposedDebtInfo} finalSaleId={finalSaleId} />}
    </>
  )
}

export default SearchResultContainer
